<template>
  <div class="container">
    <!-- <header>
      {{ documentTitle }}
    </header> -->
    <!-- Custom HTML footer -->
    <div class="hide-on-print" style="width: 500px">
      <title-block title="Logboek" class="accountstitle" :callback="GetOrRefreshData"></title-block>
      <b-field label="Project">
        <b-autocomplete
          v-model="projectFilter"
          placeholder="selecteer of filter een project"
          :keep-first="false"
          :open-on-focus="true"
          :data="filteredDataObj"
          :custom-formatter="displayName"
          @select="option => (selectedProject = option)"
          :clearable="true"
          @input="projectChangedHandler"
        >
        </b-autocomplete>
      </b-field>

      <!-- <b-field label="Filter Projects bij naam">
        <b-input v-model="projectFilter" style="width: 421px"></b-input>
      </b-field> -->

      <!-- <b-field label="Project">
        <b-select placeholder="Selecteer een project" @input="projectChangedHandler">
          <option v-for="project in filteredProjects" :value="project" :key="project.projectId">
            {{ `${project.projectId}: ${project.name}` }}
          </option>
        </b-select>
      </b-field> -->

      <b-field label="Gebouw">
        <b-select placeholder="Selecteer een gebouw" @input="buildingChangedHandler" expanded>
          <option v-for="building in buildings" :value="building" :key="building.buildingId">
            {{ building.name }}
          </option>
        </b-select>
      </b-field>

      <b-field label="Verdieping">
        <b-select placeholder="Selecteer een verdieping" @input="storyChangedHandler" expanded>
          <option v-for="floor in floors" :value="floor" :key="floor.storyId">{{ floor.name }}</option>
        </b-select>
      </b-field>

      <b-field label="Zone">
        <b-select placeholder="Selecteer zone" @input="zoneChangedHandler" expanded>
          <option v-for="zone in zones" :value="zone" :key="zone.zoneId">{{ zone.name }}</option>
        </b-select>
      </b-field>
      <br />
      <br />

      <h2 v-if="!hasOpenings && selectedZone">Geen sparingen gevonden.</h2>
    </div>

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>

    <div id="forprint" v-if="selectedZone != null">
      <div class="filterbox hide-on-print">
        <h2>Filter op `id op tekening` gescheiden door een spatie, bijv: 9 14 27</h2>
        <!-- <input v-model="filterids" /> -->
        <textarea v-model="filterids" rows="5" cols="30" />
      </div>

      <div class="only-show-on-print">
        <h4 class="title is-4" style="margin: 2px">Logboek:</h4>
        <table>
          <tr>
            <td>Project</td>
            <td>{{ selectedProject ? selectedProject.name : '' }}</td>
          </tr>
          <tr>
            <td>Gebouw</td>
            <td>{{ selectedBuilding ? selectedBuilding.name : '' }}</td>
          </tr>
          <tr>
            <td>Verdieping</td>
            <td>{{ selectedFloor ? selectedFloor.name : '' }}</td>
          </tr>
          <tr>
            <td>Zone</td>
            <td>{{ selectedZone ? selectedZone.name : '' }}</td>
          </tr>
        </table>
      </div>

      <div class="printblock bordered" v-for="opening in filteredopenings" :key="opening.openingId">
        <div class="columns">
          <div class="column">
            <table class="printblock-table">
              <tr>
                <td>Qr code</td>
                <td>{{ opening.tagId }}</td>
                <td>Gebruiker</td>
                <td-user :username="opening.lastUser" />
                <!-- <td>{{ opening.lastUser | stripEmail }}</td> -->
              </tr>
              <tr>
                <td>Id op tekening</td>
                <td>{{ opening.idOnDrawing }}</td>
                <td>Datum</td>
                <td>{{ opening.lastDate | prettyDate }}</td>
              </tr>
              <tr>
                <td>Kamer</td>
                <td>{{ opening.room }}</td>
                <td>Status</td>
                <td v-if="opening.photos !== null && opening.photos.length > 0">{{ opening.lastStatus | status }}</td>
              </tr>
              <tr>
                <td>Brandwerendheid</td>
                <td>{{ opening.fireRating }}</td>
                <td>Commentaar</td>
                <td v-if="opening.photos !== null && opening.photos.length > 0">{{ opening.lastComment }}</td>
              </tr>
              <tr>
                <td>BSC</td>
                <td>{{ opening.wallFloorAssembly }}</td>
              </tr>
              <tr>
                <td>Opmerking</td>
                <td colspan="3">{{ opening.comment }}</td>
              </tr>
            </table>
          </div>

          <div class="column is-one-third logbook-values">
            <div v-if="opening.lastphoto">
              <img :src="opening.lastphoto.uri" class="photo" />
            </div>
          </div>
        </div>

        <div class="penetrant">
          <h3>Doorvoeren:</h3>
          <div v-for="penetrant in opening.penetrants" :key="penetrant.penetrantId">
            <table class="printblock-table">
              <tr>
                <td width="8%">Type</td>
                <td width="40%">{{ penetrant.type }}</td>
                <td width="8%">Afmeting</td>
                <td width="8%">{{ penetrant.sizeCategory }}</td>
                <td width="8%">Aantal</td>
                <td width="6%">{{ penetrant.count }}</td>
                <td width="6%">Isolatie</td>
                <td width="16%">{{ penetrant.isolation }}</td>
              </tr>
              <tr>
                <td>Systeem</td>
                <td>{{ penetrant.system }}</td>
                <td>Lengte</td>
                <td>{{ penetrant.length }}</td>
                <td>Complexiteit</td>
                <td>{{ penetrant.complexityFactor }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- <footer v-if="selectedZone != null">Logboek gecreerd op {{ new Date().toISOString().slice(0, 10) }}</footer> -->
  </div>
</template>

<script>
/* eslint-disable */
import LogbookItemLabel from './LogbookItemLabel'
import ProjectService from '../../services/projectService'
import OpeningService from '../../services/openingService'
import TitleBlock from '@/components/General/TitleBlock'
import _ from 'lodash'
import TdUser from '../General/TdUser.vue'

export default {
  components: {
    item: LogbookItemLabel,
    TitleBlock,
    TdUser
  },

  filters: {
    prettyDate: function (value) {
      if (!value) return ''
      const d = new Date(value)
      return `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`
    },
    // stripEmail: function (value) {
    //   if (!value) return ''
    //   if (!value.includes('@')) return value

    //   let i = value.indexOf('@')
    //   return value.substring(0, i)
    // },
    status: function (value) {
      if (!value) return 'no value'
      let res = ''

      switch (value) {
        case 0:
          //none
          res = 'Geen'
          break
        case 1:
          //quote
          res = 'Offerteopname: geen QR'
          break
        case 2:
          //preliminaryPending
          res = 'Vooropname: niet akkoord'
          break
        case 3:
          //preliminaryReady
          res = 'Vooropname: akkoord'
          break
        case 4:
          //assemblyPending
          res = 'Montage: niet akkoord'
          break
        case 5:
          //assemblyReady
          res = 'Montage: akkoord'
          break
        case 6:
          //postAssemblyInspectionAccepted
          res = 'Inspectie: akkoord'
          break
        case 7:
          //externalInspectionAccepted
          res = 'Inspectie: niet akkoord'
          break
        case 8:
          //periodicalInspectionAccepted
          res = 'Inspectie periodiek: akkoord'
          break
        case 9:
          //mutation
          res = 'Mutatie: reparatie/herstel'
          break
        case 10:
          //report
          res = 'Meld: niet akkoord'
          break
        default:
          res = 'no match: ' + value
          break
      }
      return res
    }
  },

  data() {
    return {
      projects: [],
      selectedProject: null,
      buildings: [],
      selectedBuilding: null,
      floors: null,
      selectedFloor: null,
      zones: null,
      selectedZone: null,
      projectId: null,
      openings: [],
      isLoading: false,
      documentTitle: '',
      filterids: '',
      projectFilter: ''
    }
  },

  computed: {
    hasOpenings: function () {
      return this.openings != null && this.openings.length > 0
    },
    filteredopenings: function () {
      if (this.filterids == '') {
        return this.openings
      }
      return this.openings.filter(o => this.filteridarr.includes(o.idOnDrawing))
    },
    filteredProjects: function () {
      if (this.projectFilter == '') {
        return this.projects
      }
      return this.projects.filter(p => p.name.toLowerCase().includes(this.projectFilter.toLowerCase()))
    },
    filteridarr: function () {
      return this.filterids.split(' ').map(item => Number(item))
    },
    filteredDataObj() {
      return this.projects.filter(option => {
        return option.name.toString().toLowerCase().indexOf(this.projectFilter.toLowerCase()) >= 0
      })
    }
  },

  beforeCreate() {
    ProjectService.getProjectList().then(res => {
      this.projects = res.data.projects
    })
  },

  methods: {
    GetOrRefreshData() {
      this.selectedProject = null
      this.selectedBuilding = null
      this.selectedFloor = null
      this.selectedZone = null
    },
    displayName(value) {
      if (!value) return ''
      return `${value.projectId}: ${value.name}`
    },
    projectChangedHandler() {
      if (!this.selectedProject || !this.selectedProject.projectId) {
        console.log('clearing selections')
        this.selectedZone = null
        this.selectedProject = null
        this.buildings = null
        this.selectedBuilding = null
        this.selectedFloor = null
        this.floors = []
        this.zones = []
        return
      } else {
        this.projectId = this.selectedProject.projectId
        ProjectService.getProject(this.projectId).then(res => {
          this.selectedProject = res.data
          this.buildings = _.sortBy(res.data.buildings, 'name')
          this.selectedBuilding = null
          this.selectedFloor = null
          this.selectedZone = null
          this.floors = []
          this.zones = []
        })
      }
    },
    buildingChangedHandler(value) {
      this.selectedBuilding = value
      this.floors = value.stories
      this.selectedFloor = null
      this.selectedZone = null
      this.zones = []
    },
    storyChangedHandler(value) {
      this.zones = value.zones
      this.selectedZone = null
      this.selectedFloor = value
    },
    zoneChangedHandler(value) {
      if (!this.selectedProject) return

      this.isLoading = true

      this.selectedZone = value
      // set the title of the page so that when saving as pdf the filename matches the project, floor, zone info
      if (this.selectedProject.name == this.selectedBuilding.name) {
        this.documentTitle = `${this.selectedProject.name} - Logboek ${this.selectedFloor.name} - ${this.selectedZone.name}`
      } else {
        this.documentTitle = `${this.selectedProject.name}, ${this.selectedBuilding.name} - Logboek ${this.selectedFloor.name} - ${this.selectedZone.name}`
      }
      document.title = this.documentTitle
      //refresh bearerToken
      this.$store.dispatch('getBearerToken')

      // get all openings for this zoneId
      OpeningService.getOpeningsForZone(this.projectId, value.zoneId).then(res => {
        this.openings = res.data.openings.map(o => this.mapLastMod(o))
        this.isLoading = false
      })
    },
    getUser() {
      this.$store.dispatch('getUser')
    },
    mapLastMod(opening) {
      // if(opening.tagId == 184011){
      //   console.log(opening);
      // }
      opening.lastStatus = 0
      opening.lastComment = opening.comment
      opening.lastUser = opening.dbUser
      opening.lastDate = opening.dbDate

      if (opening.photos !== null && opening.photos.length > 0) {
        opening.lastphoto = opening.photos[0]

        //set the last status to the first photos status
        opening.lastStatus = opening.photos[0].registrationType

        for (let index = 0; index < opening.photos.length; index++) {
          const element = opening.photos[index]
          if (element && element.captureTime > opening.lastphoto.captureTime) {
            opening.lastphoto = element
            opening.lastUser = element.captureUser
            opening.lastDate = element.captureTime
            opening.lastComment = element.comment
            opening.lastStatus = element.registrationType
          }
        }
      }
      return opening
    }
  }
}
</script>

<style lang="scss">
// footer,
// header {
//   font-size: 11px;
//   color: black;
//   visibility: hidden;
// }
.filterbox {
  margin-bottom: 20px;
  h2 {
    font-weight: bold;
    margin-bottom: 5px;
  }
  textarea {
    width: 100%;
  }
}

@page {
  size: A4;
  margin: 0.4;
}

// .custom-footer-page-number:after {
//   content: counter(page);
// }

@media print {
  #Header,
  #Footer {
    display: none !important;
  }
  // footer {
  //   position: fixed;
  //   bottom: 0;
  //   visibility: visible;
  //   display: block;
  // }
  // header {
  //   position: fixed;
  //   top: 0;
  //   visibility: visible;
  //   display: block;
  //   margin-bottom: 20pt;
  // }

  .content-block,
  p {
    page-break-inside: avoid;
  }

  html,
  body {
    width: 210mm;
    height: 297mm; //297mm;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Office/Logbook.vue